var $ = require( "jquery" );
window.jQuery = $; window.$ = $;
// import ModalVideo from 'modal-video';
import slick from 'slick-carousel';
import Macy from "macy";
import simpleParallax from 'simple-parallax-js';


import * as ScrollMagic from "scrollmagic";
import { ScrollMagicPluginIndicator} from "scrollmagic-plugins";
import { TweenMax, TimelineMax } from "gsap";
import { ScrollMagicPluginGsap } from "scrollmagic-plugins";

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
ScrollMagicPluginIndicator(ScrollMagic);

// const controller = new ScrollMagic.Controller();

// new ScrollMagic.Scene({ triggerElement: ".anime-1" })
//   .setTween(".anime-1", 0.5, { opacity: 0 })
//   .addTo(controller);

/*------------------------------------------------------------------------*\
   = Parallax Magic
\*------------------------------------------------------------------------*/


    // function bgParallax(elImg, elOffset) {

        var controller = new ScrollMagic.Controller;
        $('section').each(function(index, elem) {

          // Create Animations
          var el = $(this).find('.anime-1');
          var el2 = $(this).find('.anime-2');
          var windowHeight = $(window).height();              

            var tl = new TimelineMax ()
            .add([ TweenMax.to(el, 20, { "clip-path" : "inset(0px 0px 0px 0px)" })])
            
            // .eventCallback('onComplete', function(){
            //     console.log('look mom');
            // })

            var scene = new ScrollMagic.Scene({
              triggerElement: this,
              triggerHook: 1,
              reverse: true,
              offset: -230,              
              duration: '100%'
            })
            // .setClassToggle(this, "act")
            .setTween(tl)
            // .addIndicators({
            //     name: 'fade scene',
            //     colorTrigger: 'blue',
            //     colorStart: 'green',
            //     colorEnd: 'red'
            //  })
             .addTo(controller);
        });

    // }

    // bgParallax('.anime-1', '100px');



(function() {	

	// show first content by default
	$('#tabs-nav li:first-child').addClass('active');
	$('.content').hide();
	$('.content:first').show();

	// click function
	$('#tabs-nav li').click(function(){
	  $('#tabs-nav li').removeClass('active');
	  $(this).addClass('active');
	  $('.content').hide();
	  
	  var activeTab = $(this).find('a').attr('href');
	  $(activeTab).fadeIn();
	  return false;
	});

	$('#nav-icon3').click(function(){
		$(this).toggleClass('open');
	});




  function elSlider() {
	  	if ($('.carousel').length) {
	  		$('.carousel').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
				var i = (currentSlide ? currentSlide : 0) + 1;
				$('.carousel-current').text( i + ' of ' + slick.slideCount); 
			}).slick({
		          dots : false,
		          infinite: true,
		          slidesToShow: 1,
		          arrows: true,
		          fade: true,
		          prevArrow : '.control.prev',
		          nextArrow : '.control.next',
		          adaptiveHeight: true,
		      });
	  	}
  }
  elSlider();

  if ($('.slider').length) {
		$('.slider').slick({
			  appendDots : ".pagination",
			  dots : true,
	          infinite: true,
	          slidesToShow: 1,
	          waitForAnimate: true,
	          arrows: true,
	          fade: false,
	          prevArrow : '.control.prev',
	          nextArrow : '.control.next',
	          adaptiveHeight: true,
		});
	}

function slideMe(name, totalSlideToShow, centerSlide = false, infiniteSlide = false, pagination = '.pagination', fade = false, slidesToShow = 2) {
  	if ($(name).length) {
	  	$(name).each(function(key, item) {
	  		var id = $(this).attr("id");
	  		var sliderId = '#' + id;
	  		var arrowPrev = '#' + id + ' + div .prev';
	  		var arrowNext = '#' + id + ' + div .next';

	  		var thisPagination = $(this).next('.pagination').attr('id', 'pagination-' + id);
	  		console.log(thisPagination);

	  		// alert(arrowNext);

	  		$(sliderId).on('beforeChange', function(event, slick, currentSlide, nextSlide){
				// $('.title-h2 > div').fadeOut();
			}).on('afterChange', function(event, slick, currentSlide, nextSlide){
				// $('.title-h2 > div').fadeIn();
			}).slick({
				  appendDots : (thisPagination),
				  dots : true,
		          infinite: infiniteSlide,
		          slidesToShow: totalSlideToShow,
				  centerMode: centerSlide,
				  centerPadding: '20%',
		          waitForAnimate: false,
		          arrows: true,
		          fade: fade,
		          prevArrow : (arrowPrev),
		          nextArrow : (arrowNext),
		          adaptiveHeight: true,
		          swipe: true,
		          swipeToSlide: true,
		          edgeFriction: 0,
		          touchThreshold: 4,
		          touchMove: true,
		          responsive: [
			      		{
			      			breakpoint: 960,
			      			settings: {
			      				slidesToShow: slidesToShow
			      			}
		          		},
		          		{
			      			breakpoint: 599,
			      			settings: {
			      				slidesToShow: 1
			      		}
		          	},
		          ]
			});
	  	  });
  		}
	}

	slideMe('[class*="slider-"]', 4, false, true);
	slideMe('[class*="carousel-"]', 1, true, true);
	slideMe('[class*="rounded-"]', 1, false, true, '.dots', false, 1);

	$('.scroller').slick({
		arrows: false,
	  slidesToShow: 6,
	  slidesToScroll: 1,
	  autoplay: true,
	  autoplaySpeed: 2000,
	  speed: 2000,
	  cssEase: 'ease',
	  easing: 'linear',
	});

	/* Mobile menu */
	$('.menu-icon').click(function() {
		  $(this).toggleClass('on');
		  $('.mobile-menu').fadeToggle();
		  $('body').toggleClass('overflow');
		  if($(this).hasClass('on')) {
		  	$('#tabs').css('z-index', 1)
		  } else {
		  	$('#tabs').css('z-index', 52)
		  }
	}); 

	$('.mobile-menu').find('.icon-toggle').click(function() {
	  $(this).parent().toggleClass('on');
	  $(this).next('ul').slideToggle();  
	});

	$('.menu-icon-anim').click(function() {
		$(this).toggleClass('on'); 
	});

	$('.search.btn, .search-icon').click(function() {
		// $('.modal').fadeIn(300);
	});
	$('.modal .close').click(function() {
		// $('.modal').fadeOut(300);
	});

	// Drop down
	$("ul.menu > li").hover(function () {
	    $('body').toggleClass('hover-active');
	 });

	$('.accordion').find('li .heading').click(function() {
		var $this = $(this).parent();
			$this.toggleClass('active');			
			$this.find('.blurb').slideToggle('slow', function() {
				$('html, body').stop().animate({
				    'scrollTop': $(this).parent().offset().top - $(this).prev().height()
				}, 720, 'swing');					
			});
			// Close others items if open			
			$this.prevAll().find('.blurb').slideUp(500);
			$this.nextAll().find('.blurb').slideUp(500);			
			setTimeout(function() {
				$this.prevAll().removeClass('active');
				$this.nextAll().removeClass('active');
			}, 500);
	});
})();


// Masonry Grids
if($('.masonry').length) {
	$('.masonry').each(function(index){
	     var macy = Macy({
		    container: this,
		    trueOrder: true,
		    waitForImages: false,
		    // margin: 42,
		    columns: 2,
		    margin: {
		    	x: 60,
		    	y: 30,
		    },
		    breakAt: {
		        767: 1,
		    }
		}).recalculate(true);
	});
}


$( window ).on( "load", function() {
    var image = document.querySelectorAll('.element');
		var image2 = document.querySelectorAll('.element-2');
		var image3 = document.querySelectorAll('.element-3');
		var circle = document.querySelectorAll('.circle');
		var dots = document.querySelectorAll('.anime-1');
		var bigCircle = document.querySelectorAll('.anime-3');
		
		new simpleParallax(dots, {
			overflow: true,
			orientation: 'down',
			delay: 0.7,
			transition: 'ease'
		});
		new simpleParallax(bigCircle, {
			overflow: true,
			orientation: 'down',
			delay: 0.9,
			transition: 'ease'
		});

		new simpleParallax(image, {
			overflow: true,
			orientation: 'down',
			delay: .7,
			customWrapper: 'overflow-img',
			transition: 'cubic-bezier(0.16, 1, 0.3, 1)'
		});

		new simpleParallax(image2, {
			overflow: false,
			orientation: 'up',
			delay: 1.5,
			scale: 1.2,
			customWrapper: 'overflow-img',
			transition: 'cubic-bezier(0.16, 1, 0.3, 1)'
		}); 

		new simpleParallax(image3, {
			overflow: true,
			orientation: 'left',
			delay: 1.5,
			customWrapper: 'overflow-img',
			transition: 'cubic-bezier(0.16, 1, 0.3, 1)'
		});    

		function getImgHeight() {
			var imgHeight = $('.clip-path').height();
			$('.clip-path .simpleParallax').height(imgHeight);
			console.log(imgHeight)
		}
		getImgHeight();
});




// Lightbox_me
(function($){$.fn.lightbox_me=function(options){return this.each(function(){var opts=$.extend({},$.fn.lightbox_me.defaults,options),$overlay=$(),$self=$(this),$iframe=$('<iframe id="foo" style="z-index: '+(opts.zIndex+1)+';border: none; margin: 0; padding: 0; position: absolute; width: 100%; height: 100%; top: 0; left: 0; filter: mask();"/>');if(opts.showOverlay){var $currentOverlays=$(".js_lb_overlay:visible");if($currentOverlays.length>0){$overlay=$('<div class="lb_overlay_clear js_lb_overlay"/>')}else{$overlay=$('<div class="'+opts.classPrefix+'_overlay js_lb_overlay"/>')}}$('body').append($self.hide()).append($overlay);if(opts.showOverlay){setOverlayHeight();$overlay.css({position:'absolute',width:'100%',top:0,left:0,right:0,bottom:0,zIndex:(opts.zIndex+2),display:'none'});if(!$overlay.hasClass('lb_overlay_clear')){$overlay.css(opts.overlayCSS)}}if(opts.showOverlay){$overlay.fadeIn(opts.overlaySpeed,function(){setSelfPosition();$self[opts.appearEffect](opts.lightboxSpeed,function(){setOverlayHeight();setSelfPosition();opts.onLoad()})})}else{setSelfPosition();$self[opts.appearEffect](opts.lightboxSpeed,function(){opts.onLoad()})}if(opts.parentLightbox){opts.parentLightbox.fadeOut(200)}$(window).resize(setOverlayHeight).resize(setSelfPosition).scroll(setSelfPosition);$(window).bind('keyup.lightbox_me',observeKeyPress);if(opts.closeClick){$overlay.click(function(e){closeLightbox();e.preventDefault})}$self.delegate(opts.closeSelector,"click",function(e){closeLightbox();e.preventDefault()});$self.bind('close',closeLightbox);$self.bind('reposition',setSelfPosition);function closeLightbox(){var s=$self[0].style;if(opts.destroyOnClose){$self.add($overlay).remove()}else{$self.add($overlay).hide()}if(opts.parentLightbox){opts.parentLightbox.fadeIn(200)}if(opts.preventScroll){$('body').css('overflow','')}$iframe.remove();$self.undelegate(opts.closeSelector,"click");$self.unbind('close',closeLightbox);$self.unbind('repositon',setSelfPosition);$(window).unbind('resize',setOverlayHeight);$(window).unbind('resize',setSelfPosition);$(window).unbind('scroll',setSelfPosition);$(window).unbind('keyup.lightbox_me');opts.onClose()}function observeKeyPress(e){if((e.keyCode==27||(e.DOM_VK_ESCAPE==27&&e.which==0))&&opts.closeEsc){closeLightbox()}}function setOverlayHeight(){if($(window).height()<$(document).height()){$overlay.css({height:$(document).height()+'px'});$iframe.css({height:$(document).height()+'px'})}else{$overlay.css({height:'100%'})}}function setSelfPosition(){var s=$self[0].style;$self.css({left:'50%',marginLeft:($self.outerWidth()/2)*-1,zIndex:(opts.zIndex+3)});if(($self.height()+80>=$(window).height())&&($self.css('position')!='absolute')){var topOffset=$(document).scrollTop()+40;$self.css({position:'absolute',top:topOffset+'px',marginTop:0})}else if($self.height()+80<$(window).height()){if(opts.centered){$self.css({position:'fixed',top:'50%',marginTop:($self.outerHeight()/2)*-1})}else{$self.css({position:'fixed'}).css(opts.modalCSS)}if(opts.preventScroll){$('body').css('overflow','hidden')}}}})};$.fn.lightbox_me.defaults={appearEffect:"fadeIn",appearEase:"",overlaySpeed:250,lightboxSpeed:300,closeSelector:".close",closeClick:true,closeEsc:true,destroyOnClose:false,showOverlay:true,parentLightbox:false,preventScroll:false,onLoad:function(){},onClose:function(){},classPrefix:'lb',zIndex:999,centered:false,modalCSS:{top:'40px'},overlayCSS:{background:'black',opacity:.3}}})(jQuery);

function triggerLeadershipModal() {
	$('.trigger').each(function(key, item) {		
			var id = $(this).attr("id");
		  var triggerId = '#' + id;
		  var modalId = '#' + id + '-modal';

			$(triggerId).parent().click(function(e) {
				// console.log(this);
		    $(modalId).lightbox_me({
		    	closeClick: false,
		        centered: true, 
		        onLoad: function() {},
	        	onClose: function() {},
		        });
		    e.preventDefault();
		});
	});
}

triggerLeadershipModal();

// Trigger leadership modal on browser resize
$(window).resize(function() {
	triggerLeadershipModal();
});

$(function() {
	$(window).scroll(function () {
	    var scrollTop = $(window).scrollTop();
	    var height = $(window).height();
	    $('.brand-name').css({
	        'opacity': ((height - scrollTop) / height)
	    });
	});
});



	/**
	* jquery.matchHeight-min.js v0.5.2
	* http://brm.io/jquery-match-height/
	* License: MIT
	*/
	(function(b){b.fn.matchHeight=function(a){if("remove"===a){var d=this;this.css("height","");b.each(b.fn.matchHeight._groups,function(b,a){a.elements=a.elements.not(d)});return this}if(1>=this.length)return this;a="undefined"!==typeof a?a:!0;b.fn.matchHeight._groups.push({elements:this,byRow:a});b.fn.matchHeight._apply(this,a);return this};b.fn.matchHeight._apply=function(a,d){var c=b(a),e=[c];d&&(c.css({display:"block","padding-top":"0","padding-bottom":"0","border-top-width":"0","border-bottom-width":"0",
	height:"100px"}),e=k(c),c.css({display:"","padding-top":"","padding-bottom":"","border-top-width":"","border-bottom-width":"",height:""}));b.each(e,function(a,c){var d=b(c),e=0;d.each(function(){var a=b(this);a.css({display:"block",height:""});a.outerHeight(!1)>e&&(e=a.outerHeight(!1));a.css({display:""})});d.each(function(){var a=b(this),c=0;"border-box"!==a.css("box-sizing")&&(c+=g(a.css("border-top-width"))+g(a.css("border-bottom-width")),c+=g(a.css("padding-top"))+g(a.css("padding-bottom")));
	a.css("height",e-c)})});return this};b.fn.matchHeight._applyDataApi=function(){var a={};b("[data-match-height], [data-mh]").each(function(){var d=b(this),c=d.attr("data-match-height");a[c]=c in a?a[c].add(d):d});b.each(a,function(){this.matchHeight(!0)})};b.fn.matchHeight._groups=[];b.fn.matchHeight._throttle=80;var h=-1,f=-1;b.fn.matchHeight._update=function(a){if(a&&"resize"===a.type){a=b(window).width();if(a===h)return;h=a}-1===f&&(f=setTimeout(function(){b.each(b.fn.matchHeight._groups,function(){b.fn.matchHeight._apply(this.elements,
	this.byRow)});f=-1},b.fn.matchHeight._throttle))};b(b.fn.matchHeight._applyDataApi);b(window).bind("load resize orientationchange",b.fn.matchHeight._update);var k=function(a){var d=null,c=[];b(a).each(function(){var a=b(this),f=a.offset().top-g(a.css("margin-top")),h=0<c.length?c[c.length-1]:null;null===h?c.push(a):1>=Math.floor(Math.abs(d-f))?c[c.length-1]=h.add(a):c.push(a);d=f});return c},g=function(a){return parseFloat(a)||0}})(jQuery);


	$('.equal').matchHeight();

	

